import React from "react";
import SitesList from "../../Sites/SitesList";

const Sites = () => {
  return (
    <>
      <div className={"mb-2"}>
        <SitesList />
      </div>
    </>
  );
};

export default Sites;
